<div class="content-container" fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div *ngFor="let slide of slides" class="swiper-slide" [ngClass]="{ 'swiper-slide-active': slides.indexOf(slide) === 1 }">
          <img src="/assets/images/carousel/{{ slide.image }}" alt="">
          <p>{{ slide.caption }}</p>
      </div>
    </div>

    <div class="swiper-button-prev" (click)="previous()"></div>
    <div class="swiper-button-next" (click)="next()"></div>
  </div>
</div>